import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import FirstTimeLogin from "@/components/auth/first-time-login";
import {
  AuthLeftPanel,
  AuthMobileLogo,
  AuthRightPanel,
} from "@/components/auth/auth-layout";

export const Route = createFileRoute("/_public/auth/first-time-login")({
  component: FirstTimeLoginPage,
});

function FirstTimeLoginPage() {
  const navigate = useNavigate();
  // "Configura tu cuenta" usa el OTP por email. Sin RESEND (on-prem) no funciona;
  // aunque ocultemos el enlace, protegemos la ruta ante acceso directo por URL.
  // La primera configuración en on-prem se hace con el link de activación admin.
  const emailEnabled = useQuery(
    api.system.onboarding.queries.isPasswordResetEmailEnabled,
  );

  useEffect(() => {
    if (emailEnabled === false) navigate({ to: "/auth/sign-in" });
  }, [emailEnabled, navigate]);

  if (emailEnabled === false) return null;

  return (
    <div className="relative min-h-screen">
      <AuthLeftPanel
        headline="Configura tu cuenta y empieza a construir."
        subtitle="Verifica tu correo y crea una contraseña. Tu equipo ya te está esperando en Heskala."
        badge=""
      />

      <AuthRightPanel>
        <AuthMobileLogo />
        <FirstTimeLogin provider="password" />
      </AuthRightPanel>
    </div>
  );
}
